// extracted by mini-css-extract-plugin
module.exports = {"titleIcon":"ViewChargeAffirm_titleIcon__8kEb2","inputPhoneContainer":"ViewChargeAffirm_inputPhoneContainer__31S0D"};